import React, { useCallback, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { TransactionSorting } from "ee-nestjs-interfaces";
import { TransactionTable } from "../Table";
import { DateRangeSelector, Dropdown, Radio, TextInput, } from "ee-react-components";
import { INTEGRATION_TO_OCPI_DISPLAY_NAME } from "ee-utils";
import { DownloadAsyncFileButton } from "../DownloadAsyncFileButton";
export var Transactions = function (_a) {
    var resourceUrlBase = _a.resourceUrlBase, earliestTransaction = _a.earliestTransaction, isNoc = _a.isNoc;
    var _b = useState([
        new Date(),
        new Date(),
    ]), dateRange = _b[0], setDateRange = _b[1];
    var _c = useState(TransactionSorting.SESSION_START), sortState = _c[0], setSortState = _c[1];
    var _d = useState(null), emspName = _d[0], setEmspName = _d[1];
    var _e = useState(null), faultCodeFilter = _e[0], setFaultCodeFilter = _e[1];
    var _f = useState(null), maxPeakPower = _f[0], setMaxPeakPower = _f[1];
    var _g = useState(null), maxConsumedEnergyKwh = _g[0], setMaxConsumedEnergyKwh = _g[1];
    var _h = useState(null), hasFaultCode = _h[0], setHasFaultCode = _h[1];
    var _j = useState(null), includeOnlyHasPayment = _j[0], setIncludeOnlyHasPayment = _j[1];
    var _k = useState(null), trackingFitler = _k[0], setTrackingFilter = _k[1];
    var onFaultCodeFilterChange = useCallback(function (e) {
        var value = e.target.value;
        if (!value || value.trim() === "") {
            setFaultCodeFilter(null);
        }
        else {
            setFaultCodeFilter(value);
        }
    }, [setFaultCodeFilter]);
    var onMaxPeakPowerChange = useCallback(function (e) {
        var value = e.target.value;
        if (!value || value.trim() === "") {
            setMaxPeakPower(null);
        }
        else {
            setMaxPeakPower(value);
        }
    }, [setMaxPeakPower]);
    var onMaxConsumedEnergyChanged = useCallback(function (e) {
        var value = e.target.value;
        if (!value || value.trim() === "") {
            setMaxConsumedEnergyKwh(null);
        }
        else {
            setMaxConsumedEnergyKwh(value);
        }
    }, [setMaxConsumedEnergyKwh]);
    var apiSearchParams = new URLSearchParams();
    apiSearchParams.append("useNoc", isNoc.toString());
    if (sortState) {
        apiSearchParams.append("sort", sortState);
    }
    if (faultCodeFilter) {
        apiSearchParams.append("faultCode", faultCodeFilter);
    }
    if (maxPeakPower) {
        apiSearchParams.append("maxPeakPower", maxPeakPower);
    }
    if (maxConsumedEnergyKwh) {
        apiSearchParams.append("maxConsumedEnergyKwh", maxConsumedEnergyKwh);
    }
    if (hasFaultCode != null) {
        apiSearchParams.append("hasFaultCode", hasFaultCode);
    }
    if (includeOnlyHasPayment != null) {
        apiSearchParams.append("includeOnlyHasPayment", includeOnlyHasPayment);
    }
    if (trackingFitler != null) {
        apiSearchParams.append("trackingFilter", trackingFitler);
    }
    if (emspName != null) {
        apiSearchParams.append("emspName", emspName);
    }
    var items = [
        { name: "No filter", value: null },
        { name: "Has Fault Code", value: true },
        { name: "Does not have a Fault Code", value: false },
    ];
    var onlyPaymentItems = [
        { name: "Has A Payment", value: null },
        { name: "No filter", value: false },
    ];
    var trackingItems = [
        { name: "Exclude Atypical", value: null },
        { name: "Include Atypical", value: false },
        { name: "Only Atypical", value: true },
    ];
    return (React.createElement("div", { className: "flex flex-col gap-y-[32px]" },
        React.createElement(DateRangeSelector, { dateRange: dateRange, setDateRange: setDateRange, firstDate: new Date(earliestTransaction) }),
        React.createElement("div", { className: "flex flex-row gap-x-[32px] items-center" },
            React.createElement("label", { className: "font-N7 text-black-600" }, "Sort By"),
            React.createElement(Dropdown, { items: [
                    {
                        name: "Session Start",
                        value: TransactionSorting.SESSION_START,
                        selectedLabel: "Select",
                    },
                    {
                        name: "Session End",
                        value: TransactionSorting.SESSION_END,
                    },
                    {
                        name: "Energy Delivered",
                        value: TransactionSorting.ENERGY_DELIVERED,
                    },
                    {
                        name: "Transaction Amount",
                        value: TransactionSorting.TRANSACTION_AMOUNT,
                    },
                    { name: "Charger ID", value: TransactionSorting.CHARGER_ID },
                    { name: "Peak Power", value: TransactionSorting.PEAK_POWER },
                ], onClick: setSortState, currentSelection: sortState }),
            React.createElement("div", { className: "flex flex-row gap-x-4 items-center" },
                React.createElement("label", { className: "font-N7 text-black-600" }, "Filter Third Party Source"),
                React.createElement(Dropdown, { items: [
                        {
                            name: "None",
                            value: undefined,
                            selectedLabel: "None",
                        },
                    ].concat(Array.from(INTEGRATION_TO_OCPI_DISPLAY_NAME.entries()).map(function (_a) {
                        var integration = _a[0], displayName = _a[1];
                        return ({
                            name: displayName,
                            value: integration,
                        });
                    })), onClick: setEmspName, currentSelection: emspName })),
            isNoc && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex flex-row gap-x-4 items-center" },
                    React.createElement("label", { className: "font-N7 text-black-600" }, "Filter By Fault Code"),
                    React.createElement(TextInput, { type: "number", onChange: onFaultCodeFilterChange, defaultValue: faultCodeFilter }),
                    React.createElement("label", { className: "font-N7 text-black-600" }, "Max Peak Power"),
                    React.createElement(TextInput, { type: "number", onChange: onMaxPeakPowerChange, defaultValue: maxPeakPower }))))),
        isNoc && (React.createElement(Disclosure, null, function (_a) {
            var open = _a.open;
            return (React.createElement(React.Fragment, null,
                React.createElement(Disclosure.Button, { className: "bg-black-1000 hover:bg-black-800 rounded-[10px] px-[16px] py-[8px] flex flex-row gap-x-[32px] w-3/5 justify-between" },
                    React.createElement("label", { className: "font-N6" }, "Additional Filters"),
                    open ? (React.createElement(ChevronDownIcon, { className: "w-[16px] h-[16px]" })) : (React.createElement(ChevronUpIcon, { className: "w-[16px] h-[16px]" }))),
                React.createElement(Disclosure.Panel, { className: "w-full" },
                    React.createElement("div", { className: "flex flex-row gap-x-4 items-center" },
                        React.createElement("label", { className: "font-N7 text-black-600" }, "Filter by Most Energy Delivered"),
                        React.createElement(TextInput, { type: "number", onChange: onMaxConsumedEnergyChanged, defaultValue: maxConsumedEnergyKwh }),
                        React.createElement("label", { className: "font-N7 text-black-600" }, "Filter by Has Fault Code"),
                        React.createElement(Radio, { items: items, value: hasFaultCode, setValue: setHasFaultCode })),
                    React.createElement("div", { className: "flex flex-row gap-x-4 items-center mt-[16px]" },
                        React.createElement("label", { className: "font-N7 text-black-600" }, "Filter Atypical Testing"),
                        React.createElement(Radio, { items: trackingItems, value: trackingFitler, setValue: setTrackingFilter }),
                        React.createElement("label", { className: "font-N7 text-black-600" }, "Filter Only Payment"),
                        React.createElement(Radio, { items: onlyPaymentItems, value: includeOnlyHasPayment, setValue: setIncludeOnlyHasPayment })))));
        })),
        React.createElement("div", { className: "flex flex-col w-fit gap-y-4" },
            React.createElement("div", { className: "ml-auto mr-4" },
                React.createElement(DownloadAsyncFileButton, { resourceUrl: "".concat(resourceUrlBase, "/csv/").concat(dateRange[0].toISOString(), "/").concat(dateRange[1].toISOString(), "?").concat(apiSearchParams.toString()), labelIdle: "Download CSV", labelLoading: "Generating CSV..." })),
            React.createElement(TransactionTable, { buildRowLink: function (row) { return "/transaction/".concat(row.transactionId); }, resourceUrl: "".concat(resourceUrlBase, "/").concat(dateRange[0].toISOString(), "/").concat(dateRange[1].toISOString(), "?").concat(apiSearchParams.toString()), maxRows: 20, isNoc: isNoc, refreshInterval: 0 }))));
};
